import { CounterState, Action } from 'src/store/types';
import { CounterActions } from './actions';

const initialState: CounterState = { value: 0 };

export const counterReducer = (
  state: CounterState = initialState,
  action: Action,
): CounterState => {
  switch (action.type) {
    case CounterActions.INCREMENT:
      return { value: state.value + 1 };
    case CounterActions.DECREMENT:
      return { value: state.value - 1 };
    case CounterActions.INCREMENT_BY:
      return { value: state.value + (action.payload ?? 0) };
    case CounterActions.RESET:
      return { value: 0 };
    default:
      return state;
  }
};

export const getCounterInitialState = (): CounterState => initialState;
